import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Sparkle } from './Sparkle';
import { HeartHandshakeIcon, HeadsetIcon, TrendingUpIcon, GlobeIcon } from 'lucide-react';
import { LazyGuideModal } from './LazyModals';
export function BusinessModel() {
  const [guideOpen, setGuideOpen] = useState(false);
  return <section id="ablauf" className="w-full px-4 pb-6 pt-10 sm:px-6 sm:pb-8 sm:pt-12" data-id="element-67" data-mp="s96vph66p5r1">
      <div className="mx-auto max-w-[1300px]" data-id="element-68" data-mp="1fz151oraoc6j">
        <div className="text-center" data-id="element-69" data-mp="1fw57w2n9trj5">
          <span className="mb-4 block text-xs font-semibold uppercase tracking-[0.25em] text-white" style={{
          fontSize: "16px"
        }} data-id="element-70" data-mp="1jzuskh0troyw">
            Deine Chance aus deiner Superkraft Geld zu machen
          </span>
          <div className="relative inline-block" data-id="element-71" data-mp="1axty1rwz7h0x">
            <Sparkle className="animate-sparkle -left-2 -top-4 h-5 w-5 sm:-left-9 sm:top-1 sm:h-7 sm:w-7" data-id="element-72" data-mp="1b0px5jkk8bqy" />
            <Sparkle className="animate-sparkle-fast right-4 bottom-1 h-4 w-4 sm:-right-8 sm:h-5 sm:w-5" data-id="element-73" data-mp="3vp44pmsm07ns" />
            <h2 className="font-display text-gold-3d mx-auto max-w-4xl text-2xl font-extrabold uppercase leading-[1.15] sm:text-3xl lg:text-4xl" style={{
            fontSize: "36px"
          }} data-id="element-74" data-mp="26i7p73ldwj11">
              Das Geschäftsmodell einfach erklärt
            </h2>
          </div>
          <p className="mx-auto mt-6 max-w-3xl text-base leading-relaxed text-white" data-id="element-75" data-mp="2gi88ipj96z58">
            <span className="block" data-id="element-76" data-mp="2bgss5as0tgt6">
              Wir zeigen dir, wie du als Hot Sales Girl für Unternehmen, Coaches und Dienstleister
              hochpreisige Angebote verkaufst und für erfolgreiche Abschlüsse attraktive Provisionen
              erhältst.
            </span>
            <span className="mt-3 block" data-id="element-77" data-mp="2z7epa70hlgoe">
              Du lernst die entscheidenden Sales-Skills, wie du passende High-Ticket-Projekte findest
              und erfolgreich in Remote Sales startest. Zusätzlich profitierst du von unserem
              internationalen Netzwerk und spannenden Kontakten.
            </span>
          </p>
          <button type="button" onClick={() => setGuideOpen(true)} className="btn-gold-shiny mt-4 inline-flex items-center justify-center gap-2 rounded-full px-6 py-2.5 text-sm font-semibold" data-id="element-78" data-mp="3482m59becrqj">
            Guide kostenlos sichern
          </button>
        </div>

        <div className="mt-6 grid gap-5 md:grid-cols-3 md:gap-4" data-id="element-79" data-mp="3l5j01omsomdu">
          {/* Card 1 */}
          <motion.div initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.45,
          delay: 0.1
        }} className="flex flex-col rounded-3xl bg-white p-6 shadow-xl md:p-5 lg:p-8" data-id="element-80" data-mp="3pzn7sa3vwyfz">
            <div className="mb-6 flex h-12 w-12 items-center justify-center rounded-2xl bg-hot-50 text-hot-500 md:mb-4 md:h-10 md:w-10" data-id="element-81" data-mp="crsgyevy46bj">
              <HeartHandshakeIcon className="h-6 w-6 md:h-5 md:w-5" data-id="element-82" data-mp="29l436k4eggwn" />
            </div>
            <h3 className="font-heading text-xl font-bold leading-tight text-neutral-900 md:text-base lg:text-xl" data-id="element-83" data-mp="2einilncu2zq6">
              Gespräche auf Augenhöhe
            </h3>
            <p className="mt-3 text-sm leading-relaxed text-neutral-600" data-id="element-84" data-mp="228xt2294h1b2">
              Du führst Gespräche mit Menschen, die bereits echtes Interesse an einem Angebot haben.
              Dabei geht es nicht darum, jemanden zu überreden, sondern zuzuhören, die richtigen
              Fragen zu stellen und gemeinsam herauszufinden, ob das Angebot wirklich zu der Person
              passt. Authentisch, auf Augenhöhe und ohne Verkaufsdruck.
            </p>
          </motion.div>

          {/* Card 2 */}
          <motion.div initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.45,
          delay: 0.2
        }} className="flex flex-col rounded-3xl bg-white p-6 shadow-xl md:p-5 lg:p-8" data-id="element-85" data-mp="2g0cf6hybtimc">
            <div className="mb-6 flex h-12 w-12 items-center justify-center rounded-2xl bg-hot-50 text-hot-500 md:mb-4 md:h-10 md:w-10" data-id="element-86" data-mp="zlt72hzmuiy9">
              <HeadsetIcon className="h-6 w-6 md:h-5 md:w-5" data-id="element-87" data-mp="2oeyvr7njadfc" />
            </div>
            <h3 className="font-heading text-xl font-bold leading-tight text-neutral-900 md:text-base lg:text-xl" data-id="element-88" data-mp="2t7s03uf3bjqw">
              Alles, was du tun musst: Gute Gespräche führen
            </h3>
            <p className="mt-3 text-sm leading-relaxed text-neutral-600" data-id="element-89" data-mp="2ji8ewi3wndsv">
              Du brauchst weder eine eigene Reichweite noch ein eigenes Produkt und musst dich auch
              nicht um Werbung kümmern. Die Unternehmen sorgen für die Interessenten und
              vereinbarten Termine – diese landen automatisch in deinem Kalender. Dein einziger
              Fokus liegt nur auf dem Führen der Gespräche.
            </p>
          </motion.div>

          {/* Card 3 (Wide, below) */}
          <motion.div initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.45,
          delay: 0.3
        }} className="order-last flex flex-col rounded-3xl bg-gradient-to-b from-white to-hot-50/50 p-6 shadow-xl md:col-span-3 lg:flex-row lg:items-center lg:gap-10 lg:p-8" data-id="element-90" data-mp="1lsdgs925oz1s">
            <div className="lg:flex-1" data-id="element-91" data-mp="hu9rkkxev09f">
              <div className="mb-6 flex h-12 w-12 items-center justify-center rounded-2xl bg-hot-50 text-hot-500" data-id="element-92" data-mp="dtzpvkgniw0d">
                <TrendingUpIcon className="h-6 w-6" data-id="element-93" data-mp="3m9jbpyeztc5e" />
              </div>
              <h3 className="font-heading text-xl font-bold leading-tight text-neutral-900" data-id="element-94" data-mp="3m7f00uaur8uk">
                Attraktives Einkommen bei flexibler Zeiteinteilung
              </h3>
              <p className="mt-3 max-w-2xl text-sm leading-relaxed text-neutral-600" data-id="element-95" data-mp="3v3e7wgy4zs8w">
                Im High-Ticket-Sales können bereits einzelne erfolgreiche Abschlüsse mehrere Hundert
                Euro einbringen. Je nach Unternehmen und Angebot sind 500–1.500 € pro Abschluss
                möglich. So kannst du dir ein Top-Einkommen aufbauen, ohne 40+ Stunden pro Woche in
                einem klassischen 9-to-5-Job festzuhängen.
              </p>
            </div>

            {/* Decorative Chart Element */}
            <div className="mt-8 flex flex-1 items-center justify-center pb-2 pt-6 lg:mt-0 lg:pb-0 lg:pt-8" data-id="element-96" data-mp="16gaze88ttth8">
              <div className="relative aspect-[2/1] w-full max-w-[180px] lg:max-w-[320px]" data-id="element-97" data-mp="1g8gys31erd6g">
                <svg viewBox="0 0 200 100" className="h-full w-full overflow-visible" data-id="element-98" data-mp="ikq4kbxk5xfn">
                  <path d="M0,80 Q20,80 40,50 T80,60 T120,20 T160,40 T200,10" fill="none" stroke="#fe4da2" strokeWidth="4" strokeLinecap="round" data-id="element-99" data-mp="in2vvfp7hk5d" />
                  <circle cx="0" cy="80" r="4" fill="#fe4da2" data-id="element-100" data-mp="xiqv0qfo3h2e" />
                  <circle cx="40" cy="50" r="4" fill="#fe4da2" data-id="element-101" data-mp="23yksniosnyk9" />
                  <circle cx="80" cy="60" r="4" fill="#fe4da2" data-id="element-102" data-mp="2405mt7775fhl" />
                  <circle cx="120" cy="20" r="4" fill="#fe4da2" data-id="element-103" data-mp="28vtbzmloi8n3" />
                  <circle cx="160" cy="40" r="4" fill="#fe4da2" data-id="element-104" data-mp="3tfopp4thnhmn" />
                  <circle cx="200" cy="10" r="4" fill="#fe4da2" data-id="element-105" data-mp="3th9hwnsbyohc" />
                  
                </svg>
                
                {/* Labels */}
                <div className="absolute left-[0%] top-[62%] -translate-x-1/4 -translate-y-1/2 rounded-full bg-white px-2 py-0.5 text-[10px] font-bold text-hot-500 shadow-sm border border-hot-100" data-id="element-106" data-mp="3joby8eblqth5">
                  3.000€
                </div>
                <div className="absolute left-[20%] top-[35%] -translate-x-1/2 -translate-y-1/2 rounded-full bg-white px-2 py-0.5 text-[10px] font-bold text-hot-500 shadow-sm border border-hot-100" data-id="element-107" data-mp="39p3a423f492p">
                  5.500€
                </div>
                <div className="absolute left-[60%] top-[5%] -translate-x-1/2 -translate-y-1/2 rounded-full bg-white px-2 py-0.5 text-[10px] font-bold text-hot-500 shadow-sm border border-hot-100" data-id="element-108" data-mp="2vs7xjznyjzhw">
                  8.700€
                </div>
                <div className="absolute left-[100%] top-[10%] -translate-x-[35%] -translate-y-[105%] rounded-full bg-white px-2 py-0.5 text-[10px] font-bold text-hot-500 shadow-sm border border-hot-100" data-id="element-109" data-mp="txyv3ne214xx">
                  10k€
                </div>
              </div>
            </div>
          </motion.div>

          {/* Card 4 (Wide) */}
          <motion.div initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.45,
          delay: 0.4
        }} className="flex flex-col gap-6 rounded-3xl bg-white p-6 shadow-xl md:gap-4 md:p-5 lg:p-8" data-id="element-110" data-mp="3u8v6g8qyiokc">
            <div className="flex-1" data-id="element-111" data-mp="36cz7cptzjdgz">
              <div className="mb-6 flex h-12 w-12 items-center justify-center rounded-2xl bg-hot-50 text-hot-500 md:mb-4 md:h-10 md:w-10" data-id="element-112" data-mp="3baiy2p7vdipt">
                <GlobeIcon className="h-6 w-6 md:h-5 md:w-5" data-id="element-113" data-mp="14l4b9ik7phjv" />
              </div>
              <h3 className="font-heading text-xl font-bold leading-tight text-neutral-900 md:text-base lg:text-xl" data-id="element-114" data-mp="19jnydmajkzdt">
                Arbeite von überall auf der Welt
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-neutral-600" data-id="element-115" data-mp="2p2dhf154sb17">
                Alles, was du brauchst, sind dein Smartphone und eine stabile Internetverbindung. Ob
                von zu Hause, aus deinem Lieblingscafé oder unterwegs auf Reisen – du entscheidest,
                wo dein Arbeitsplatz heute ist. Arbeite ortsunabhängig und gestalte dein Leben frei
                und selbstbestimmt.
              </p>
            </div>
            
            {/* Decorative Globe Element */}
            <div className="relative mx-auto flex h-32 w-32 shrink-0 items-center justify-center rounded-full border-2 border-dashed border-hot-200 md:h-24 md:w-24 lg:h-36 lg:w-36" data-id="element-116" data-mp="3mpm1crphhc13">
              <div className="absolute h-full w-full animate-[spin_20s_linear_infinite] rounded-full border border-hot-100" data-id="element-117" data-mp="1sbte7vebloam" />
              <div className="absolute h-full w-full animate-[spin_15s_linear_infinite_reverse] rounded-full border border-hot-100" style={{
              transform: 'rotateX(60deg)'
            }} data-id="element-118" data-mp="1ndjhvhgv0hnf" />
              <div className="absolute h-full w-full animate-[spin_25s_linear_infinite] rounded-full border border-hot-100" style={{
              transform: 'rotateY(60deg)'
            }} data-id="element-119" data-mp="2o0t1q89sihh" />
              
              <div className="absolute -top-3 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-full bg-white px-2 py-1 text-[10px] font-semibold text-hot-500 shadow-md" data-id="element-120" data-mp="3twenmgdn5uia">Dubai</div>
              <div className="absolute top-1/2 -left-6 -translate-y-1/2 whitespace-nowrap rounded-full bg-white px-2 py-1 text-[10px] font-semibold text-hot-500 shadow-md" data-id="element-121" data-mp="qctrbtcd72f9">Zypern</div>
              <div className="absolute top-1/2 -right-6 -translate-y-1/2 whitespace-nowrap rounded-full bg-white px-2 py-1 text-[10px] font-semibold text-hot-500 shadow-md" data-id="element-122" data-mp="gmh6s14jv994">Kapstadt</div>
              <div className="absolute -bottom-3 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-full bg-white px-2 py-1 text-[10px] font-semibold text-hot-500 shadow-md" data-id="element-123" data-mp="1954nz5gfe44x">Bali</div>
            </div>
          </motion.div>
        </div>
        
        <div className="mt-8 text-center" data-id="element-124" data-mp="2n2h4feonj3fy">
          <a href="#guide" className="btn-gold-shiny inline-flex items-center justify-center gap-2 rounded-full px-6 py-2.5 text-sm font-semibold" data-id="element-125" data-mp="2ryfpasaru3bm">
            Kennenlerncall buchen
          </a>
        </div>
      </div>

      <LazyGuideModal open={guideOpen} onClose={() => setGuideOpen(false)} data-id="element-126" data-mp="30xj7zv610gpl" />
    </section>;
}